import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import QuickMenu from '../../components/QuickMenu/QuickMenu';
import { getAdvertisementByGuid, getActiveAdvertisements } from '../../api/advertisementService';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';

const AdvertisementDetail = () => {
  const [advertisement, setAdvertisement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const { urlTag } = useParams();
  const guidFromState = location.state?.guid;

  const fetchAdvertisementDetail = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      let guid = guidFromState;

      // Eğer state'den guid gelmemişse (direkt URL girişi), urlTag ile bul
      if (!guid && urlTag) {
        console.log('GUID not found in state, fetching by urlTag:', urlTag);
        const allAdvertisementsResponse = await getActiveAdvertisements(1, 1000);
        
        if (allAdvertisementsResponse.isSuccess && allAdvertisementsResponse.data?.items) {
          const foundAdvertisement = allAdvertisementsResponse.data.items.find(
            item => item.urlTag === urlTag
          );
          
          if (foundAdvertisement) {
            guid = foundAdvertisement.guid;
            console.log('Found advertisement with guid:', guid);
          } else {
            console.log('Advertisement not found with urlTag:', urlTag);
            setError('İlan bulunamadı');
            setLoading(false);
            return;
          }
        } else {
          console.log('Failed to fetch advertisements list');
          setError('İlanlar yüklenirken bir hata oluştu');
          setLoading(false);
          return;
        }
      }

      if (!guid) {
        console.log('No guid available');
        setError('İlan bilgisi bulunamadı');
        setLoading(false);
        return;
      }

      console.log('Fetching advertisement detail for guid:', guid);
      const response = await getAdvertisementByGuid(guid);
      console.log('Advertisement detail response:', response);
      
      if (response.isSuccess && response.data) {
        setAdvertisement(response.data);
        setError(null);
      } else {
        setError(`İlan detayı yüklenirken bir hata oluştu: ${JSON.stringify(response)}`);
      }
    } catch (error) {
      console.error('Error in fetchAdvertisementDetail:', error);
      setError(`İlan detayı yüklenirken bir hata oluştu: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  }, [urlTag, guidFromState]);

  useEffect(() => {
    fetchAdvertisementDetail();
  }, [fetchAdvertisementDetail]);

  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), 'dd MMMM yyyy', { locale: tr });
    } catch (error) {
      return dateString;
    }
  };

  if (loading) {
    return (
      <div className="advertisements-detail-page">
        <div className="container-fluid">
          <div className="loading">Yükleniyor...</div>
        </div>
      </div>
    );
  }

  if (error || !advertisement) {
    return (
      <div className="advertisements-detail-page">
        <div className="container-fluid">
          <div className="alert alert-danger">{error || 'İlan bulunamadı'}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="advertisements-detail-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="advertisements-detail">
              <div className="advertisements-detail-title">
                <h2 id="advertisements-header">{advertisement.header}</h2>
              </div>

              <div className="advertisements-detail-content">
                <div className="advertisements-detail-boxes">
                  <div className="advertisements-detail-box">
                    <div className="advertisements-detail-box-left">
                      <span>İlan Konusu</span>
                    </div>
                    <div className="advertisements-detail-box-right">
                      <p id="advertisements-subject">{advertisement.header}</p>
                    </div>
                  </div>
                  <div className="advertisements-detail-box">
                    <div className="advertisements-detail-box-left">
                      <span>İlan Birimi</span>
                    </div>
                    <div className="advertisements-detail-box-right">
                      <p id="advertisements-department">{advertisement.department}</p>
                    </div>
                  </div>
                  {advertisement.fileUrl && (
                    <div className="advertisements-detail-box file">
                      <div className="advertisements-detail-box-left">
                        <span>Doküman URL</span>
                      </div>
                      <div className="advertisements-detail-box-right">
                        <p id="advertisements-url">
                          <a href={advertisement.fileUrl} target="_blank" rel="noopener noreferrer">
                            İlan Dosyasını İndir
                          </a>
                        </p>
                      </div>
                    </div>
                  )}
                  {advertisement.address && (
                    <div className="advertisements-detail-box">
                      <div className="advertisements-detail-box-left">
                        <span>İlanın Yapılacağı Adres</span>
                      </div>
                      <div className="advertisements-detail-box-right">
                        <p id="advertisements-address">{advertisement.address}</p>
                      </div>
                    </div>
                  )}
                  <div className="advertisements-detail-box">
                    <div className="advertisements-detail-box-left">
                      <span>İlan Tarihi</span>
                    </div>
                    <div className="advertisements-detail-box-right">
                      <p id="advertisements-date">{formatDate(advertisement.date)}</p>
                    </div>
                  </div>
                  <div className="advertisements-detail-box">
                    <div className="advertisements-detail-box-left">
                      <span>İlan Metni</span>
                    </div>
                    <div className="advertisements-detail-box-right">
                      <p id="advertisements-detail" dangerouslySetInnerHTML={{ __html: advertisement.detail }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvertisementDetail;
